module.exports = __webpack_public_path__ + "img/11-stylists-microlines.png";